import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { MainLayout } from '../../components/layout/MainLayout';
import { GameLayout } from '../../components/layout/GameLayout';
import { HomePage } from '../../pages/home/HomePage';
import { GamePage } from '../../pages/game/GamePage';
import { PrivacyPage } from '../../pages/legal/PrivacyPage';
import { NotFoundPage } from '../../pages/NotFoundPage';
import { VerifiedPage } from '../../pages/auth/VerifiedPage';
import { VerificationFailedPage } from '../../pages/auth/VerificationFailedPage';

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}> 
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Route>
      <Route element={<GameLayout />}> 
        <Route path="/game" element={<GamePage />} />
      </Route>
      {/* Auth verification routes */}
      <Route path="/auth/verified" element={<VerifiedPage />} />
      <Route path="/auth/verification-failed" element={<VerificationFailedPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};


